import { Link } from "react-router-dom";
import news1 from "../../assets/img/informationandnews/news1.png";
import { LazyLoadImage } from "react-lazy-load-image-component";
import { motion } from "framer-motion";
import Slider from "react-slick";
import { useEffect, useState } from "react";
import axios from "axios";
import NotFound from "../shared/NotFound";
import { FaRegUser } from "react-icons/fa6";
import helper from "../../utils/helper";
import sanitizeHTML from "../../utils/sanitize";

interface News {
    id: string;
    title: string;
    news: string;
    category: string;
    offer_start_date: string;
    offer_end_date: string;
    description: string;
    created_at: string;
    img_news: string;
    slug_title: string;
    author: {
        name: string;
    };
}

interface NewsCartdProps {
    news: News;
}

export default function InformationAndNews() {
    const [data, setData] = useState<News[]>([]);
    const getData = async () => {
        try {
            const response = await axios.get(`${process.env.REACT_APP_API_ENDPOINT}/news?limit=6`);
            if (response && response.data && response.data.data) {
                setData(response.data.data.data);
            } else {
                setData([]);
            }
        } catch (error) {
            console.log("Error fetching data:", error);
        }
    }

    const settings = {
        dots: false,
        infinite: false,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
        // responsive: [
        //     {
        //         breakpoint: 768, // Untuk mobile
        //         settings: {
        //             slidesToShow: 1,
        //             slidesToScroll: 1,
        //             infinite: false
        //         },
        //     },
        //     {
        //         breakpoint: 1024, // Untuk tablet atau desktop kecil
        //         settings: {
        //             slidesToShow: 3,
        //             slidesToScroll: 3,
        //         },
        //     },
        // ],
    };

    useEffect(() => {
        getData();
    }, []);

    return (
        <div className="max-w-screen-2xl mx-auto pt-16 pb-60 p-5 md:p-5 lg:p-16">
            <div className="flex flex-col sm:flex-row justify-between text-sm mt-5">
                <div className="flex space-x-5 mb-4 sm:mb-0 whitespace-nowrap">
                    <h1 className="text-2xl font-poppinsBold text-bprDarkBlue">INFORMASI & BERITA</h1>
                </div>
                <div className="flex items-center justify-start w-full sm:items-center sm:justify-end">
                    <Link to="/informasi-dan-berita" className="font-poppinsBold text-bprDarkBlue text-lg">Selengkapnya</Link>
                </div>
            </div>
            <motion.div
                initial={{ opacity: 0, y: -100 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 1.2 }}
                className="mt-14"
            >
                <div className="block md:hidden">
                    <Slider {...settings}>
                        {data.length === 0 ? (
                            <NotFound></NotFound>
                        ) : (
                            data.map((news) => (
                                <div key={news.id} className="px-2">
                                    <NewsCard news={news} />
                                </div>
                            ))
                        )}
                    </Slider>
                </div>
                {data.length === 0 ? (
                    <div className="hidden md:block">
                        <NotFound />
                    </div>
                ) : (
                    <div className="hidden md:grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-3 gap-3">
                        {data.map((news) => (
                            <NewsCard key={news.id} news={news} />
                        ))}
                    </div>
                )}
            </motion.div>
        </div>
    );
}

function NewsCard({ news }: NewsCartdProps) {
    return (
        <div  className="border shadow-md">
            <div className="w-full h-auto  overflow-hidden ">
                <LazyLoadImage
                    src={process.env.REACT_APP_API_ENDPOINT + '/news/getimg/' + news.img_news}
                    alt="offers"
                    effect="blur"
                    className="w-full h-[200px] object-cover object-center"
                    wrapperProps={{
                        style: { transitionDelay: '1s' },
                    }}
                ></LazyLoadImage>
                <div className="px-3 pt-4 flex flex-row justify-between space-x-2 items-center ">
                    <div className="flex items-center space-x-2">
                        <span className="text-sm pt-1 text-bprYellow font-poppinsBold">{news.category.toLocaleUpperCase()}</span>
                        <span className="text-sm pt-1 ml-auto text-black">  {new Intl.DateTimeFormat('id-ID', { day: 'numeric', month: 'long', year: 'numeric' }).format(new Date(news.created_at))}</span>
                    </div>
                </div>
                <div className="flex items-center space-x-3 px-3 pt-3  text-textPrimary">
                    <FaRegUser /> <span className="text-sm pt-1" dangerouslySetInnerHTML={{ __html: news.author.name }}></span>
                </div>
                <div className="px-3 py-4">
                    <div className="font-poppinsBold text-2xl mb-2" dangerouslySetInnerHTML={{ __html: news.title }}></div>
                    <p className="text-textPrimary" dangerouslySetInnerHTML={{ __html: helper.handleDescription(news.description, 100) }}></p>
                </div>
                <div className="px-3 pt-2 pb-5">
                    <Link to={`/detail-informasi-dan-berita/${news.slug_title}`}  className="text-sm font-poppinsBold hover:text-blue-500">{`SELENGKAPNYA >`} </Link>
                </div>
            </div>
        </div>
    );
}
